// Paste a spreadsheet / web table → a Markdown table (PARITY P301; Mac MacComposerPaste, Android
// RichContentTextField, Windows ComposerMediaUi — all over core/pastedTable.ts). Excel, Numbers,
// Sheets and every browser put tab-separated rows on the plain-text flavour; pasted as-is that is a
// wall of tabs the renderer has no reason to read as a table. Runs AFTER the attachments' paste
// handler: files win (a pasted screenshot is a file), then a table, then the ordinary text paste.
import type { ClipboardEvent } from 'react';
import { PastedTable } from '../../../core/pastedTable';

/** True when the paste was a table and went into the field as Markdown. */
export function insertPastedTable(e: ClipboardEvent<HTMLTextAreaElement>): boolean {
  if (e.defaultPrevented) return false;
  const table = PastedTable.markdown(e.clipboardData?.getData('text/plain') ?? '');
  if (table == null) return false;
  e.preventDefault();
  const el = e.currentTarget;
  // Through the browser's own editing: undo keeps it and React's onChange sees the input.
  if (!document.execCommand('insertText', false, table)) {
    el.setRangeText(table, el.selectionStart, el.selectionEnd, 'end');
    el.dispatchEvent(new Event('input', { bubbles: true }));
  }
  return true;
}
